// Pause after which a buffered text field hands its draft to the owning state.
export const TEXT_FIELD_COMMIT_DELAY_MS = 300;
